// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard__intro h2 {
  margin: 0 0 0.35rem;
  font-size: clamp(1.6rem, 4vw, 2.2rem);
  font-weight: 700;
}

.dashboard__subtitle {
  margin: 0 0 1.5rem;
  color: var(--color-text-muted);
  font-size: 0.95rem;
}

.dashboard__intro:has(.dashboard__error) .dashboard__subtitle {
  margin-bottom: 0.5rem;
}

.dashboard__error {
  margin: 0 0 1.5rem;
  color: var(--color-secondary);
  font-size: 0.9rem;
  font-weight: 600;
}

.dashboard__metrics {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 1rem;
}

.metric-card {
  padding: 1.1rem 1.15rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius);
  background: var(--color-surface-raised);
  box-shadow: var(--shadow);
}

.metric-card--highlight .metric-card__header h3,
.metric-card--highlight .metric-card__subtext {
  color: var(--color-accent);
}

.metric-card__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.metric-card__header h3 {
  margin: 0;
  color: var(--color-text-muted);
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.metric-card__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: var(--color-btn);
  color: var(--color-icon);
}

.metric-card__icon svg {
  width: 18px;
  height: 18px;
}

.metric-card__value {
  margin: 0 0 0.35rem;
  font-size: clamp(1.6rem, 3vw, 2rem);
  font-weight: 700;
  line-height: 1.1;
}

.metric-card__subtext {
  margin: 0;
  color: var(--color-text-muted);
  font-size: 0.82rem;
}

@media (max-width: 1100px) {
  .dashboard__metrics {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 768px) {
  .dashboard__metrics {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .dashboard__subtitle {
    margin-bottom: 1.25rem;
  }
}

.dashboard__jobs {
  margin-top: 1.75rem;
}

.dashboard__jobs-header {
  margin-bottom: 0.75rem;
}

.dashboard__jobs-header h3 {
  margin: 0 0 0.35rem;
  font-size: 1.1rem;
  font-weight: 700;
}

.dashboard__jobs-header p {
  margin: 0;
  color: var(--color-text-muted);
  font-size: 0.9rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,qCAAqC;EACrC,4BAA4B;EAC5B,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,iBAAiB;AACnB","sourcesContent":[".dashboard__intro h2 {\n  margin: 0 0 0.35rem;\n  font-size: clamp(1.6rem, 4vw, 2.2rem);\n  font-weight: 700;\n}\n\n.dashboard__subtitle {\n  margin: 0 0 1.5rem;\n  color: var(--color-text-muted);\n  font-size: 0.95rem;\n}\n\n.dashboard__intro:has(.dashboard__error) .dashboard__subtitle {\n  margin-bottom: 0.5rem;\n}\n\n.dashboard__error {\n  margin: 0 0 1.5rem;\n  color: var(--color-secondary);\n  font-size: 0.9rem;\n  font-weight: 600;\n}\n\n.dashboard__metrics {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 1rem;\n}\n\n.metric-card {\n  padding: 1.1rem 1.15rem;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius);\n  background: var(--color-surface-raised);\n  box-shadow: var(--shadow);\n}\n\n.metric-card--highlight .metric-card__header h3,\n.metric-card--highlight .metric-card__subtext {\n  color: var(--color-accent);\n}\n\n.metric-card__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin-bottom: 1rem;\n}\n\n.metric-card__header h3 {\n  margin: 0;\n  color: var(--color-text-muted);\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.metric-card__icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  background: var(--color-btn);\n  color: var(--color-icon);\n}\n\n.metric-card__icon svg {\n  width: 18px;\n  height: 18px;\n}\n\n.metric-card__value {\n  margin: 0 0 0.35rem;\n  font-size: clamp(1.6rem, 3vw, 2rem);\n  font-weight: 700;\n  line-height: 1.1;\n}\n\n.metric-card__subtext {\n  margin: 0;\n  color: var(--color-text-muted);\n  font-size: 0.82rem;\n}\n\n@media (max-width: 1100px) {\n  .dashboard__metrics {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 768px) {\n  .dashboard__metrics {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 480px) {\n  .dashboard__subtitle {\n    margin-bottom: 1.25rem;\n  }\n}\n\n.dashboard__jobs {\n  margin-top: 1.75rem;\n}\n\n.dashboard__jobs-header {\n  margin-bottom: 0.75rem;\n}\n\n.dashboard__jobs-header h3 {\n  margin: 0 0 0.35rem;\n  font-size: 1.1rem;\n  font-weight: 700;\n}\n\n.dashboard__jobs-header p {\n  margin: 0;\n  color: var(--color-text-muted);\n  font-size: 0.9rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
